import styled from '@emotion/styled/macro';

//  language=SCSS
export default styled.div`
  & {
    height: 100%;
    overflow-y: auto;
  }
`;
